import ResultProfiler from "./resultProfiler";

export default ResultProfiler;
